module.exports = __webpack_public_path__ + "img/thurrock.6130c44c.jpg";